import type { RefineStep } from "./types";

export const REFINE_STEPS: RefineStep[] = [
  { id: 1, title: "jobOffers.refine.steps.titleCategory" },
  { id: 2, title: "jobOffers.refine.steps.details" },
  { id: 3, title: "jobOffers.refine.steps.skills" },
  { id: 4, title: "jobOffers.refine.steps.description" },
  { id: 5, title: "jobOffers.refine.steps.application" },
];
